import React from "react";

const Group = ({ match }) => {
    console.log(match);
    return <div>회원그룹 설정</div>;
};

export default Group;
